import React from 'react'

const DealerHero = () => {
  return (
    <section id="c-heroDealer" className="c-sectionHero">
		<div className="container">
			<div className="row">
				<div className="col-md-6 col-sm-12 c-heroContentCol">
					<div className="c-heroContent">
						<h5 className="c-heading46Bold">Dealer-facing digital retail loan platform </h5>
						<p className="c-para22Regular text-justify">Finayo launch self-service through customers can create and manage their own account just in few clicks. With the 	self-service programme they can select their customers as per necessity.</p>
						<a href="#c-sectionRequestInfoForm" className="c-btnOrangeSolidSharp">Get in Touch &nbsp;&nbsp; <b>></b></a>
					</div>
				</div>
				<div className="col-md-6 col-sm-12 c-heroImgCol">
					<img src="./images/dealer/hero_dealer_main.png" className="img-fluid" alt=""/>
				</div>
			</div>
		</div>
	</section>
  )
}

export default DealerHero